import React from 'react';
import OutfitBoards from '../../components/OutfitBoards';

const OutfitBoardsView = ({ customerId }) => {
  return <OutfitBoards customerId={customerId} />;
};

export default OutfitBoardsView;
